import React, { PropsWithChildren } from "react";
import styled from "styled-components";
import { ArrowLeft } from "lucide-react";
import { NEW_LOOK_ICON_STROKE } from "common/NewLook";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

interface NewLookBackLinkProps {
  onClick: () => void;
  className?: string;
}

/** A quiet "← Back" link that opens a focused settings flow (new look). */
const NewLookBackLink = ({
  onClick,
  className,
  children,
}: PropsWithChildren<NewLookBackLinkProps>) => (
  <Wrapper type="button" onClick={onClick} className={className}>
    <ArrowLeft size={16} strokeWidth={NEW_LOOK_ICON_STROKE} />
    {children}
  </Wrapper>
);

export default NewLookBackLink;

const Wrapper = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  margin-left: -10px;
  padding: 0 10px;
  border: none;
  border-radius: ${(p) => p.theme.radii.control}px;
  background: transparent;
  color: ${(p) => getNewLookTokens(p.theme).secondary};
  font-family: inherit;
  ${newLookType.label};
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  &:hover {
    color: ${(p) => p.theme.colors.titleColor};
    background: ${(p) => p.theme.colors.cardLightBgColor};
  }
  &:focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.primaryBlue};
    outline-offset: 1px;
  }
`;
